import React from 'react'
import PropTypes from 'prop-types'

import Icon from '../../../Shared/Icon/Icon'
import Tooltip from '../../../Shared/Tooltip'

import ProductAnalyticsKeywordSearchTable from './ProductAnalyticsKeywordSearchTable'

function ProductAnalyticsKeywordSearch({
  keywords,
  searchTerm,
  activeSearchGroup,
  modalIsOpen,
  handleSubmit,
  handleChange,
  dataFetch,
  openModal,
  closeModal,
  wordCountButtonClassName,
  handleWordCountChange,
  tiersData,
}) {
  return (
    <div>
      <h2 className="content-heading__h2">
        <div className="keyword-search-title">
          Keyword Search
          <Tooltip
            tooltipClassName="tooltip--big tooltip--spaced"
            id="keyword-search--tooltip"
            content="Enter 1 keyword or click on keyword in the report above to see related keywords or phrases
          and how they perform."
          >
            <Icon type={['fal', 'question-circle']} color="grey" className="info-icon" notSpaced />
          </Tooltip>
        </div>
        <div className={`form-inline form-search ${keywords.data ? 'is-active' : ''}`}>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Enter single keyword here..."
              value={keywords.value}
              className="form-control"
              onChange={handleChange}
            />
            <button type="submit" className="btn btn-transparent">
              <Icon type="search" color="green-dark" className="info-icon" notSpaced />
            </button>
          </form>
        </div>
        <div className={`content-heading__buttons ${keywords.data ? '' : 'is-hidden'}`}>
          <div className="btn-group">
            <button
              className={wordCountButtonClassName(2)}
              onClick={() => handleWordCountChange(2)}
            >
              <Tooltip
                tooltipClassName="tooltip--medium tooltip--spaced"
                id="tabs-2words--tooltip"
                content="Shows related 2-word phrases and their performance. This can give you a better
                        idea what kind of models perform well."
              >
                2 words
              </Tooltip>
            </button>
            <button
              className={wordCountButtonClassName(3)}
              onClick={() => handleWordCountChange(3)}
            >
              <Tooltip
                tooltipClassName="tooltip--medium tooltip--spaced"
                id="tabs-3words--tooltip"
                content="Shows the performance of related 3 word phrases."
              >
                3 words
              </Tooltip>
            </button>
          </div>
        </div>
      </h2>

      {keywords.data ? (
        keywords.data.length > 0 ? (
          <ProductAnalyticsKeywordSearchTable
            keywords={keywords}
            searchTerm={searchTerm}
            activeSearchGroup={activeSearchGroup}
            modalIsOpen={modalIsOpen}
            dataFetch={dataFetch}
            openModal={openModal}
            closeModal={closeModal}
            wordCountButtonClassName={wordCountButtonClassName}
            handleWordCountChange={handleWordCountChange}
            tiersData={tiersData}
          />
        ) : (
          <div className="empty-content u-text-center">
            <p>
              Sorry, no keywords found. Try searching again or change group
            </p>
          </div>
        )
      ) : (
        <div className="keyword-search--empty">
          <div className="row">
            <div className="col-3 col-lg-2 offset-lg-2 search-icon">
              <Icon type="search" color="grey-light" className="info-icon" size="6x" notSpaced />
            </div>
            <div className="col-9 col-lg-6">
              <h3 className="content-heading__h2">Enter Keyword above to see results here</h3>
              <p>Enter <span className="text-semibold">single</span> keyword in the search bar above to see
                related
                <span className="text-green text-semibold"> 2 words</span> and
                <span className="text-green text-semibold"> 3 words</span> phrases
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

ProductAnalyticsKeywordSearch.propTypes = {
  keywords: PropTypes.object.isRequired,
  searchTerm: PropTypes.string.isRequired,
  activeSearchGroup: PropTypes.number.isRequired,
  modalIsOpen: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  dataFetch: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  wordCountButtonClassName: PropTypes.func.isRequired,
  handleWordCountChange: PropTypes.func.isRequired,
  tiersData: PropTypes.object.isRequired,
}

export default ProductAnalyticsKeywordSearch
